import './polyfills';
import '@frontend/ui-kit/index.css';
import {createRoot} from 'react-dom/client';
import * as Sentry from '@sentry/react';
import analyticsService from './analyticsService';
import App from './App';
import {ENV, ROOT, SENTRY_DSN, SEGMENT_KEY} from './constants';
import './index.scss';

if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0,
        environment: ENV
    });
}

if (SEGMENT_KEY) {
    analyticsService.load(SEGMENT_KEY);
}

createRoot(ROOT!).render(<App/>);
